// extracted by mini-css-extract-plugin
module.exports = {"container":"langSelector_container__2MGf8","flag":"langSelector_flag__2JeX5","subMenuContainer":"langSelector_subMenuContainer__2SAMc","list":"langSelector_list__183yY","link":"langSelector_link__1kmu_"};
    if(module.hot) {
      // 1745935589342
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  